var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("avue-crud", {
        ref: "crud",
        attrs: {
          option: _vm.option,
          "table-loading": _vm.loading,
          data: _vm.data,
          page: _vm.page,
          permission: _vm.permissionList,
        },
        on: {
          "row-del": _vm.rowDel,
          "search-change": _vm.searchChange,
          "search-reset": _vm.searchReset,
          "selection-change": _vm.selectionChange,
          "current-change": _vm.currentChange,
          "size-change": _vm.sizeChange,
          "refresh-change": _vm.refreshChange,
          "on-load": _vm.onLoad,
        },
        scopedSlots: _vm._u([
          {
            key: "suspensionState",
            fn: function ({ row }) {
              return [
                _c("el-tag", [
                  _vm._v(_vm._s(row.suspensionState === 1 ? "激活" : "挂起")),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.form,
          callback: function ($$v) {
            _vm.form = $$v
          },
          expression: "form",
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "流程删除",
            "append-to-body": "",
            visible: _vm.followBox,
            width: "20%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.followBox = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "删除理由" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入删除理由" },
                    model: {
                      value: _vm.deleteReason,
                      callback: function ($$v) {
                        _vm.deleteReason = $$v
                      },
                      expression: "deleteReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.followBox = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleDelete } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }